import { PROVIDER_OPTIONS } from 'components/shared/Filters/lib/filterOptions';

export const DEFAULT_FILTERS = {
  search: {
    type: 'search',
    fields: [
      { field: 'medication', label: 'Medication' },
      { field: 'product_ndc', label: 'NDC' }
    ]
  },
  date: {
    type: 'date-range',
    title: 'Date of medication',
    icon: 'calendar-mono'
  },
  prescriber: {
    queryKey: 'prescribers.options',
    title: 'Provider',
    placeholder: 'Search provider',
    icon: 'user-square-mono',
    allowed_operators: ['is', 'is not']
  },
  created_by: {
    ...PROVIDER_OPTIONS,
    allowed_operators: ['is', 'is not']
  }
};
